export default "__VITE_ASSET__B76BH2lB__"